import { render, staticRenderFns } from "./DictItemListPage.vue?vue&type=template&id=dcda59a8&scoped=true&"
import script from "./DictItemListPage.vue?vue&type=script&lang=js&"
export * from "./DictItemListPage.vue?vue&type=script&lang=js&"
import style0 from "./DictItemListPage.vue?vue&type=style&index=0&id=dcda59a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcda59a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcda59a8')) {
      api.createRecord('dcda59a8', component.options)
    } else {
      api.reload('dcda59a8', component.options)
    }
    module.hot.accept("./DictItemListPage.vue?vue&type=template&id=dcda59a8&scoped=true&", function () {
      api.rerender('dcda59a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictItemListPage.vue"
export default component.exports